<template>
    <div v-if="PCM.id">
        <h2 class="alinha-centro">Aprovação Vigente</h2>
        <div class="margem bloco2">
            <fieldset class="grid-4">
                <div>
                    <label>Status do Projeto <i v-if="podeSolicitarEdicaoStatus" class="bi-pencil-square"
                            title="Solicitar Edição" @click="abrirPedidoStatusProjeto"></i>
                    </label>
                    <select v-if="podeEditarStatusDireto" v-model="statusProjetoLocal"
                        :style="{ color: corStatusProjeto(statusProjetoLocal) }"
                        @change="editarStatusProjeto(statusProjetoLocal)">
                        <option :value="`${statusProjetoLocal}`" hidden> {{ statusProjetoLocal }} </option>
                        <option v-for="s in statusProjetoOpcoes" :key="s" :value="s"
                            :style="{ color: corStatusProjeto(s) }">{{ s }}</option>
                    </select>
                    <input v-else type="text" readonly :value="statusProjetoLocal || '—'"
                        :style="{ color: corStatusProjeto(statusProjetoLocal) }">
                </div>
                <div>
                    <label>Data Prevista de Conclusão <i v-if="podeEditar" class="bi-pencil-square"
                            title="Solicitar Edição" @click="abrirModal('dtEstimadaFinal')"></i></label>
                    <input type="date" :readonly="!podeEditar"
                        @change="atualizarPCM('dtEstimadaFinal', PCM.dtEstimadaFinal)" v-model="PCM.dtEstimadaFinal">
                </div>
                <div>
                    <label>Gerente Responsável</label>
                    <select v-model="PCM.gerentePCM_id" :disabled="!podeEditar"
                        @change="atualizarPCM('gerentePCM_id', PCM.gerentePCM_id)">
                        <option :value="null" hidden></option>
                        <option v-for="u in usuarios" :key="u.id" :value="u.id">{{ u.nomeCompleto }}</option>
                    </select>
                </div>
                <div>
                    <label>Custo Previsto Total</label>
                    <money3 :model-value="custoTotalResultados" :readonly="true" class="inputValor"
                        v-if="isGerenteOuAssessor || parteDoComite || isAuditor116"
                        title="Soma dos custos previstos das entregas" v-bind="config">
                    </money3>
                    <input v-else type="text" value="●●●●●" readonly>
                </div>
            </fieldset>
            <fieldset class="grid-1">
                <div>
                    <label>Entregas</label>
                    <draggable v-model="PCM.resultados" tag="div" class="pcm-resultados-lista"
                        :item-key="resultadoDragKey" :disabled="!podeReordenarResultados"
                        handle=".pcm-resultado-drag-handle" :animation="220" @end="onResultadosReordenados">
                        <template #item="{ element: res, index: idx }">
                            <article class="pcm-resultado-card">
                                <header class="pcm-resultado-card__cabecalho">
                                    <span class="pcm-resultado-drag-handle"
                                        :class="{ 'pcm-resultado-drag-handle--oculto': !podeReordenarResultados }"
                                        title="Arrastar para reordenar" aria-hidden="true">
                                        <i class="bi-list"></i>
                                    </span>
                                    <span class="pcm-resultado-card__indice">{{ idx + 1 }}</span>
                                    <label class="pcm-resultado-card__cabecalho-rotulo">Nome</label>
                                    <input v-model="res.nome" class="pcm-resultado-card__nome"
                                        placeholder="Título curto da entrega" :readonly="!podeEditarCamposResultado"
                                        @change="onCampoResultadoAlterado" />
                                    <span class="pcm-status-chip" :class="'pcm-status-chip--' + statusNormalizado(res)"> {{ labelStatusResultado(res) }} </span>
                                </header>
                                <div class="pcm-resultado-card__conteudo">
                                    <div>
                                        <label>Especificação da entrega</label>
                                        <textarea class="pcm-textarea" rows="3" placeholder="Descreva os detalhes..."
                                            @change="onCampoResultadoAlterado" v-model="res.descricao"
                                            :readonly="!podeEditarCamposResultado"></textarea>
                                    </div>
                                    <div>
                                        <label>Evidências</label>
                                        <textarea class="pcm-textarea" rows="3" placeholder="Descreva as evidências..."
                                            @change="onCampoResultadoAlterado" v-model="res.evidencias"
                                            :readonly="!podeEditarCamposResultado"></textarea>
                                    </div>
                                </div>
                                <div class="pcm-resultado-card__rodape">
                                    <div>
                                        <label>Data prevista de conclusão</label>
                                        <input type="date" v-model="res.dt_prevista_conclusao"
                                            :readonly="!podeEditarCamposResultado" @change="onCampoResultadoAlterado" />
                                    </div>
                                    <div>
                                        <label>Data de conclusão</label>
                                        <input v-if="podeEditarCamposResultado && isAuditor116" type="date"
                                            v-model="res.dt_conclusao" @change="onCampoResultadoAlterado"
                                            title="Auditor: ajuste da data de conclusão; demais perfis: somente leitura" />
                                        <input v-else type="text" readonly :value="formatarDataBr(res.dt_conclusao, '')"
                                            :title="res.status === 'concluido' && !res.dt_conclusao ? 'Preenchida automaticamente ao concluir' : ''"
                                            placeholder="—" />
                                    </div>
                                    <div class="pcm-resultado-card__custo">
                                        <label>Custo previsto</label>
                                        <div v-if="isGerenteOuAssessor || parteDoComite"
                                            class="pcm-celula-campo--custo">
                                            <template v-if="podeEditarCamposResultado">
                                                <p v-if="res.sem_custo" class="pcm-aviso-sem-custo"> Esta entrega não terá custo </p>
                                                <money3 v-else v-model="res.custo" class="inputValor pcm-money"
                                                    @focusout="onCampoResultadoAlterado" v-bind="config">
                                                </money3>
                                                <label class="pcm-check-sem-custo">
                                                    <input type="checkbox" :checked="!!res.sem_custo"
                                                        @change="onToggleSemCustoResultado(res, $event.target.checked)" />
                                                    <span>Sem custo</span>
                                                </label>
                                            </template>
                                            <template v-else>
                                                <div v-if="res.sem_custo" class="pcm-aviso-sem-custo"> Esta entrega não terá custo </div>
                                                <money3 v-else v-model="res.custo" :readonly="true"
                                                    class="inputValor pcm-money" v-bind="config">
                                                </money3>
                                            </template>
                                        </div>
                                        <input v-else type="text" value="●●●●●" readonly class="inputValor">
                                    </div>
                                </div>
                                <footer class="pcm-resultado-card__acoes">
                                    <template v-if="isAuditor116">
                                        <button type="button" class="pcm-acao-resultado pcm-acao-resultado--sucesso"
                                            v-if="podeEditar && res.status === 'pendente'"
                                            :disabled="!podeAlterarStatusResultados || statusNormalizado(res) === 'validado' || statusNormalizado(res) === 'concluido'"
                                            @click="definirStatusResultado(res, 'validado')"> Validar </button>
                                        <button type="button" class="pcm-acao-resultado pcm-acao-resultado--sucesso"
                                            v-if="podeEditar && res.status === 'validado'"
                                            :disabled="!podeAlterarStatusResultados || statusNormalizado(res) === 'concluido'"
                                            @click="definirStatusResultado(res, 'concluido')"> Concluir </button>
                                        <button type="button" class="pcm-acao-resultado pcm-acao-resultado--erro"
                                            v-if="podeEditar && res.status === 'pendente'"
                                            :disabled="!podeAlterarStatusResultados"
                                            @click="handleRemoverResultado(idx)"> Excluir </button>
                                    </template>
                                    <button v-if="podeSolicitarPedidoCampoResultado(res)" type="button" class="acao-secundaria pcm-btn-pedir-edicao" title="Solicitar alteração de um campo desta entrega" @click="abrirPedidoEdicaoResultado(res, idx)"> Solicitar Mudança </button>
                                    <button v-if="podeSolicitarExclusaoResultado(res)" type="button" class="pcm-acao-resultado pcm-acao-resultado--erro" title="Solicitar exclusão da entrega" @click="abrirPedidoExcluirResultado(res, idx)"> Excluir </button>
                                </footer>
                            </article>
                        </template>
                    </draggable>
                    <div v-if="podeEditarCamposResultado || podeSolicitarPedidoEdicaoResultados" class="pcm-resultados-acoes">
                        <button type="button" class="acao-secundaria" @click="handleAdicionarResultado">Adicionar entrega</button>
                    </div>
                </div>
                <div>
                    <label>Comitê de Aprovação</label>
                    <div class="tags">
                        <a v-for="u in PCM.comite_aprovacao" :key="u.id" class="membroComite">
                            <div class="alinha-v" style="gap: .5rem"> {{ u.name }} <i v-if="podeEditar" class="bi-x-circle" title="Remover Membro" @click="removerMembro(u.id)"></i>
                            </div>
                        </a>
                        <AutoCompleteComponent v-if="podeEditar" :BaseOpcoes="usuarios" @adicionar="adicionarMembro" :propPlaceholder="'Adicionar Membro'" propStyle="width: 14rem; border-radius: 20px; height: 40px; text-align: center" />
                    </div>
                </div>
                <div>
                    <label>Anexos</label>
                    <ul class="lista-anexos">
                        <li v-for="a in (PCM.anexos || [])" :key="a.id">
                            <a class="nome" :title="a.nome_original" :href="storageUrl + a.caminho" target="_blank">{{ a.nome_original }}</a>
                            <i class="bi-trash" title="Excluir Anexo" @click.stop="excluirAnexo(a.id)" hidden></i>
                        </li>
                        <li v-if="(PCM.anexos || []).length === 0"><i>Nenhum anexo</i></li>
                    </ul>
                </div>
                <div>
                    <div class="direita">
                        <div class="grid-1">
                            <div class="submit" v-if="podeEditar && podeAprovar && PCM.status === 'Aguardando Aprovação'">
                                <button class="acao-secundaria reprovar" :disabled="PCM.status === 'Reprovado'" :title="PCM.status === 'Reprovado' ? 'Já reprovado' : ''" @click="this.PCM.status = 'Reprovado', atualizarPCM('status', 'Reprovado')">Reprovar</button>
                                <button class="acao-secundaria aprovar" :disabled="PCM.status === 'Aprovado'" :title="PCM.status === 'Aprovado' ? 'Já aprovado' : ''" @click="this.PCM.status = 'Aprovado', atualizarPCM('status', 'Aprovado')">Aprovar</button>
                            </div>
                            <div class="direita" v-if="(PCM.status === 'Aprovado' || PCM.status === 'Reprovado') && PCM.dtAprovacao"> {{ PCM.status === 'Aprovado' ? 'Aprovado em' : 'Reprovado em' }} <span> {{ new Date(PCM.dtAprovacao).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <br>
        <h2 class="alinha-centro">Ata de Aprovação Inicial</h2>
        <div>
            <QuillEditor @blur="podeEditar ? atualizarPCM('ata', `${PCM.ata}`) : null" contentType="html" v-model:content="PCM.ata" :readOnly="!podeEditar" style="border-radius: 0 0 6px 6px;" />
        </div>
        <br>
        <h2 class="alinha-centro">Pedidos de Mudança</h2>
        <div v-if="pedidos_edicao && pedidos_edicao.length === 0">
            <div class="bloco2 margem alinha-centro">
                <span class="chip bg-cinza" style="font-size: 16px;"> Nenhum pedido de mudança solicitado </span>
            </div>
        </div>
        <div v-else-if="pedidos_edicao">
            <div style="margin-block: 1rem; gap: 1rem;" v-for="p, index in pedidos_edicao" :key="index" class="alinha-v">
                <h3 class="alinha-centro">{{ `${pedidos_edicao.length - index}º` }}</h3>
                <fieldset class="grid-4 bloco2 margem" style="flex-grow: 1;">
                    <div>
                        <label>Campo</label>
                        <input type="text" readonly :value="labelCampoPedido(p)">
                    </div>
                    <div>
                        <label>Valor Original</label>
                        <!-- Resultado (lista legada / novo / exclusão / atributo longo) -->
                        <textarea v-if="usaTextareaPedido(p)" :value="formatarValorPedidoExibicao(p, 'atual')" readonly></textarea>
                        <input v-else-if="metaCampoPedido(p)?.tipo === 'string' || metaCampoPedido(p)?.tipo === 'boolean'" type="text" :value="formatarValorPedidoExibicao(p, 'atual')" readonly />
                        <!-- Date -->
                        <input v-else-if="metaCampoPedido(p)?.tipo === 'date'" type="date" :value="dataParaInput(p.valor_atual)" readonly />
                        <!-- Select -->
                        <select v-else-if="metaCampoPedido(p)?.tipo === 'select'" :value="p.valor_atual" disabled style="opacity: 1; cursor: auto;">
                            <option :value="null" hidden>-</option>
                            <option v-for="o, index in metaCampoPedido(p)?.lista" :key="index"> {{ o }} </option>
                        </select>
                        <!-- Moeda -->
                        <money3 v-else-if="metaCampoPedido(p)?.tipo === 'moeda' && (isGerente || parteDoComite)" v-model="p.valor_atual" readonly v-bind="config" class="inputValor">
                        </money3>
                        <input v-else-if="metaCampoPedido(p)?.tipo === 'moeda'" type="text" value="●●●●●" readonly>
                        <input v-else type="text" :value="formatarValorPedidoExibicao(p, 'atual')" readonly />
                    </div>
                    <div>
                        <label>Novo Valor</label>
                        <textarea v-if="usaTextareaPedido(p)" :value="formatarValorPedidoExibicao(p, 'novo')" readonly></textarea>
                        <input v-else-if="metaCampoPedido(p)?.tipo === 'string' || metaCampoPedido(p)?.tipo === 'boolean'" type="text" :value="formatarValorPedidoExibicao(p, 'novo')" readonly />
                        <!-- Date -->
                        <input v-else-if="metaCampoPedido(p)?.tipo === 'date'" type="date" :value="p.novo_valor" readonly />
                        <!-- Select -->
                        <select v-else-if="metaCampoPedido(p)?.tipo === 'select'" :value="p.novo_valor" disabled style="opacity: 1; cursor: auto;">
                            <option :value="null" hidden>-</option>
                            <option v-for="o, index in metaCampoPedido(p)?.lista" :key="index"> {{ o }} </option>
                        </select>
                        <!-- Moeda -->
                        <money3 v-else-if="metaCampoPedido(p)?.tipo === 'moeda' && (isGerente || parteDoComite)" v-model="p.novo_valor" readonly v-bind="config" class="inputValor">
                        </money3>
                        <input v-else-if="metaCampoPedido(p)?.tipo === 'moeda'" type="text" value="●●●●●" readonly>
                        <input v-else type="text" :value="formatarValorPedidoExibicao(p, 'novo')" readonly />
                    </div>
                    <div>
                        <label>Solicitado Por</label>
                        <input type="text" readonly :value="p.solicitante?.name">
                    </div>
                    <div>
                        <label>Data da Solicitação</label>
                        <input type="date" :value="dataParaInput(p.created_at)" readonly>
                    </div>
                    <div :class="{ 'col-2': p.obs }">
                        <label>Justificativa</label>
                        <textarea :value="p.justificativa" readonly></textarea>
                    </div>
                    <div v-if="p.obs">
                        <label>{{ p.status === 'pendente' ? 'Observações do solicitante' : 'Observações' }}</label>
                        <textarea :value="p.obs" readonly></textarea>
                    </div>
                    <div v-if="podeEditar && p.status === 'pendente' && (PCM.nivel === 'Estratégico' ? podeAprovar : funcionalidades.includes(56))">
                        <label>Parecer do aprovador (opcional)</label>
                        <textarea v-model="obsAprovacaoPorPedido[p.id]" placeholder="Registre observações ao aprovar ou reprovar"></textarea>
                    </div>
                    <div class="pedido-mudanca-status">
                        <!-- se for estrategico somente quem tem as funcionalidade (aprovador de pcm estrategico) e (auditor)
                        podem aprovar, se nao somente quem tiver (aprovador pcm operacional) -->
                        <div class="submit direita" v-if="podeEditar && p.status === 'pendente' && (PCM.nivel === 'Estratégico' ? podeAprovar : funcionalidades.includes(56))">
                            <button class="acao-secundaria reprovar" @click="aprovarPedidoEdicao(p.id, 'reprovado')">Reprovar</button>
                            <button class="acao-secundaria aprovar" @click="aprovarPedidoEdicao(p.id, 'aprovado')">Aprovar</button>
                        </div>
                        <div v-else-if="p.status === 'pendente'" class="direita">
                            <span class="chip bg-cinza" style="font-size: 16px;"> Pendente </span>
                        </div>
                        <div v-else class="direita">
                            <span class="chip" style="font-size: 16px;" :class="p.status === 'aprovado' ? 'bg-sucesso' : 'bg-erro'"> {{ p.status === 'aprovado' ? 'Aprovado' : 'Reprovado' }} por {{ p.aprovador?.name }} </span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div v-else class="loading">
            <div></div>
        </div>
        <br>
        <h2 class="alinha-centro">Encerramento de projeto</h2>
        <div class="bloco margem">
            <EncerramentoProjeto v-model="existePedidoEncerramento" :propProjetoID="PCM.id_associacao" :podeVerOrcamento="isGerenteOuAssessor || parteDoComite || isAuditor116" :propEstimativaCusto="custoTotalResultados" :entregas="entregas" :somente-leitura="somenteLeitura" />
        </div>
    </div>
    <div class="alinha-centro txt-erro fonte-maior" v-else> Cadastro não encontrado </div>
    <ModalSolicitarEdicao :mostrar="!!pedidoEdicao" :pedido-edicao="pedidoEdicao" :campos="campos" :config="config" :usuarios="usuarios" :setores="[]" :mensagem-edicao="mensagemEdicao" @fechar="pedidoEdicao = null, mensagemEdicao = null" @solicitar="criarPedidoEdicao" />
</template>
<script>
import { dataParaInput as formatarDataParaInput, formatarDataBr } from "@/utils/date";
import service from "@/services/servicePCM"
import { consultarSetores } from "@/services/usuario-setor"
import { sso } from "roboflex-thalamus-sso-lib";
import serviceProjetos from "@/services/serviceProjetos";
import { getPermissao } from "@/services/permissao-service";
import { Money3Component } from "v-money3";
import { QuillEditor } from "@vueup/vue-quill";
import AutoCompleteComponent from "../AutoComplete/AutoCompleteComponent.vue";
import EncerramentoProjeto from "./EncerramentoProjeto.vue";
import ModalSolicitarEdicao from "@/components/Modais/PCM/ModalSolicitarEdicao.vue";
import draggable from "vuedraggable";

export default {
    name: 'reuniãoAprovação',
    components: {
        money3: Money3Component,
        ModalSolicitarEdicao,
        QuillEditor,
        AutoCompleteComponent,
        EncerramentoProjeto,
        draggable,
    },
    props: {
        propPCM: {
            required: true,
        },
        somenteLeitura: {
            type: Boolean,
            default: false,
        },
        isGerenteProjeto: {
            type: Boolean,
            default: false,
        },
        isAuditor: {
            type: Boolean,
            default: false,
        },
        projeto: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            PCM: this.propPCM,
            usuarios: [],
            idUsuario: null,
            entregas: [],
            coordenadores: [],
            funcionalidades: [],
            pedidos_edicao: null,
            campos: service.campos,
            config: {
                masked: false,
                prefix: "R$ ",
                thousands: ".",
                decimal: ",",
                precision: 2,
            },
            pedidoEdicao: null,
            mensagemEdicao: null,
            storageUrl: process.env.VUE_APP_ROOT_STORAGE,
            existePedidoEncerramento: false,
            obsAprovacaoPorPedido: {},
            statusProjetoLocal: this.projeto?.status ?? null,
        }
    },
    computed: {
        podeEditar() {
            return !this.somenteLeitura
        },
        statusProjetoOpcoes() {
            return [...(service.campos.status_projeto?.lista || [])]
        },
        /** Auditor edita status do projeto direto. */
        podeEditarStatusDireto() {
            return this.podeEditar && this.isAuditor116
        },
        /** Gerente/assessor solicita mudança de status (PCM aprovado). */
        podeSolicitarEdicaoStatus() {
            return this.podeEditar
                // && !this.isAuditor116
                && (this.isGerenteOuAssessor || this.isAuditor116)
                && this.PCM.status === 'Aprovado'
        },
        podeAprovar() {
            return this.funcionalidades.includes(111) || this.funcionalidades.includes(116) || this.parteDoComite
            // return true;
        },
        parteDoComite() {
            return (this.PCM.comite_aprovacao || []).map(i => i.id).includes(this.idUsuario) || this.isAuditor116
        },
        membroComiteAprovacao() {
            return (this.PCM.comite_aprovacao || []).map(i => i.id).includes(this.idUsuario)
        },
        isGerente() {
            return this.PCM.gerentePCM_id === this.idUsuario
        },
        isGerenteOuAssessor() {
            return this.isGerenteProjeto || this.isGerente
        },
        /** Gerente, assessor, comitê ou quem pode aprovar o PCM podem Validar/Concluir resultados */
        podeAlterarStatusResultados() {
            return this.podeEditar && (this.isGerenteOuAssessor || this.parteDoComite || this.podeAprovar)
        },
        /** Ordem dos resultados: gerente, assessor, auditor (116) ou membro do comitê */
        podeReordenarResultados() {
            return this.podeEditar && (this.isGerenteOuAssessor || this.parteDoComite || this.isAuditor116)
        },
        /** Auditor (funcionalidade 116): pode ajustar data de conclusão dos resultados. */
        isAuditor116() {
            return this.isAuditor
                || (Array.isArray(this.funcionalidades) && this.funcionalidades.includes(116))
        },
        bloquearEdicaoResultados() {
            return this.somenteLeitura || this.PCM.status === 'Aprovado'
        },
        /** Salva na API imediatamente (PCM ainda não aprovado). */
        podeSalvarResultadosDireto() {
            return this.podeEditarResultadosDireto
        },
        /** Edição direta na API quando o PCM ainda não foi aprovado. */
        podeEditarResultadosDireto() {
            return this.podeEditar && !this.bloquearEdicaoResultados
        },
        /** Gerente, assessor ou auditor: edita localmente e abre pedido de mudança com PCM aprovado. */
        podeEditarResultadosParaPedido() {
            return this.podeEditar && this.bloquearEdicaoResultados
                && (this.isGerenteOuAssessor || this.isAuditor116)
        },
        /** Exibe pedido de edição para gerente, assessor e auditores com PCM aprovado. */
        podeSolicitarPedidoEdicaoResultados() {
            return this.podeEditarResultadosParaPedido
        },
        /** Campos da tabela de resultados editáveis (somente antes da aprovação do PCM). */
        podeEditarCamposResultado() {
            return this.podeEditarResultadosDireto
        },
        custoTotalResultados: {
            get() {
                return (this.PCM.resultados || []).reduce((acc, res) => {
                    if (res?.sem_custo) return acc
                    return acc + this.converterCustoParaNumero(res?.custo)
                }, 0)
            },
            set() {
                /* derivado dos resultados; money3 somente leitura ainda emite atualizações */
            },
        },
    },
    created() {
        this.ensureResultados()
    },
    async mounted() {
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id;
        this.usuarios = (await consultarSetores()).usuarios;
        this.coordenadores = await serviceProjetos.getCoordenadores();
        this.funcionalidades = await getPermissao();
        this.ensureResultados();
        this.getPedidosEdicao()
        this.carregarEntregas()
    },
    watch: {
        propPCM: {
            handler(val) {
                this.PCM = val
                this.ensureResultados()
                this.carregarEntregas()
            }
        },
        projeto: {
            immediate: true,
            handler(val) {
                this.statusProjetoLocal = val?.status ?? null
            },
        },
    },
    methods: {
        formatarDataBr,
        corStatusProjeto(status) {
            switch (status) {
                case 'Cancelado':
                case 'Reprovado':
                    return 'var(--cor-erro)'
                case 'Aprovado':
                    return '#00B6B3'
                case 'Em andamento':
                    return 'var(--cor-ok)'
                case 'Concluído':
                    return 'var(--cor-sucesso)'
                case 'Proposto':
                case 'Suspenso':
                case 'Aguardando Aprovação':
                case 'Aguardando Entregas':
                default:
                    return '#FFA500'
            }
        },
        abrirPedidoStatusProjeto() {
            if (!this.podeSolicitarEdicaoStatus) return
            this.pedidoEdicao = {
                pcm_id: this.PCM.id,
                campo: 'status_projeto',
                valor_atual: this.statusProjetoLocal || '',
                novo_valor: null,
                justificativa: '',
                obs: '',
            }
        },
        async editarStatusProjeto(novoValor) {
            if (!this.podeEditarStatusDireto || !this.PCM.id_associacao) return
            const payload = novoValor === 'Concluído'
                ? { status: novoValor, dtTermino: formatarDataParaInput(new Date().toISOString()) }
                : { status: novoValor, dtTermino: null }
            await serviceProjetos.atualizarProjeto(this.PCM.id_associacao, payload)
            this.statusProjetoLocal = novoValor
            this.$emit('getProjeto')
        },
        async carregarEntregas() {
            const projetoId = this.PCM?.id_associacao
            if (!projetoId) {
                this.entregas = []
                return
            }
            try {
                const response = await serviceProjetos.getEntregas(projetoId)
                this.entregas = response?.projetos?.[0]?.entregas ?? []
            } catch {
                this.entregas = []
            }
        },
        ensureResultados() {
            if (!this.PCM.resultados || !Array.isArray(this.PCM.resultados)) {
                this.PCM.resultados = []
            }
            if (this.PCM.resultados.length === 0) {
                this.PCM.resultados.push({
                    nome: '',
                    problema: '',
                    descricao: this.PCM.proposito_mudanca || '',
                    evidencias: this.PCM.possivel_solucao || '',
                    dt_prevista_conclusao: null,
                    dt_conclusao: null,
                    custo: null,
                    sem_custo: false,
                    status: 'pendente',
                    __dragKey: this.novaChaveDragResultado(),
                })
            }
            this.PCM.resultados.forEach((r) => {
                if (r.nome === undefined) r.nome = ''
                if (r.problema === undefined) r.problema = ''
                if (!r.status) r.status = 'pendente'
                if (r.sem_custo == null) r.sem_custo = false
                if (r.sem_custo) r.custo = null
                if (r.dt_prevista_conclusao === undefined) r.dt_prevista_conclusao = null
                if (r.dt_conclusao === undefined) r.dt_conclusao = null
                if (r.dt_prevista_conclusao) r.dt_prevista_conclusao = String(r.dt_prevista_conclusao).slice(0, 10)
                if (r.dt_conclusao) r.dt_conclusao = String(r.dt_conclusao).slice(0, 10)
                if (r.id == null && !r.__dragKey) r.__dragKey = this.novaChaveDragResultado()
            })
        },
        novaChaveDragResultado() {
            return `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
        },
        resultadoDragKey(row) {
            if (row?.id != null) return `id-${row.id}`
            return row.__dragKey || (row.__dragKey = this.novaChaveDragResultado())
        },
        async onResultadosReordenados() {
            if (!this.podeReordenarResultados) return
            await this.salvarResultados()
        },
        statusNormalizado(res) {
            const s = (res?.status || 'pendente').toString().toLowerCase()
            if (s === 'validado' || s === 'concluido') return s
            return 'pendente'
        },
        labelStatusResultado(res) {
            const s = this.statusNormalizado(res)
            if (s === 'validado') return 'Validado'
            if (s === 'concluido') return 'Concluído'
            return 'Validação pendente'
        },
        async definirStatusResultado(res, novoStatus) {
            if (!this.podeEditar) return
            res.status = novoStatus
            await this.salvarResultados()
        },
        onCampoResultadoAlterado() {
            if (!this.podeEditar) return
            if (this.podeSalvarResultadosDireto) {
                this.salvarResultados()
            }
        },
        async onToggleSemCustoResultado(res, checked) {
            if (!this.podeEditarCamposResultado) return
            res.sem_custo = !!checked
            if (res.sem_custo) res.custo = null
            await this.salvarResultados()
        },
        async salvarResultados(resultadosExcluirIds = []) {
            if (!this.podeEditar) return
            const resultados = (this.PCM.resultados || []).map((r, i) => ({
                id: r.id,
                nome: r.nome,
                problema: r.problema,
                descricao: r.descricao,
                evidencias: r.evidencias,
                dt_prevista_conclusao: r.dt_prevista_conclusao === '' || r.dt_prevista_conclusao == null
                    ? null
                    : String(r.dt_prevista_conclusao).slice(0, 10),
                dt_conclusao: r.dt_conclusao === '' || r.dt_conclusao == null
                    ? null
                    : String(r.dt_conclusao).slice(0, 10),
                sem_custo: !!r.sem_custo,
                custo: r.sem_custo || r.custo === '' || r.custo == null
                    ? null
                    : this.converterCustoParaNumero(r.custo),
                status: this.statusNormalizado(r),
                indice: i,
            }))
            await service.salvarResultadosPcm(this.PCM.id, resultados, resultadosExcluirIds)
            this.PCM.estimativa_custo = this.custoTotalResultados
            this.$emit('getProjeto')
        },
        adicionarResultado() {
            this.ensureResultados()
            this.PCM.resultados.push({
                nome: '',
                problema: '',
                descricao: '',
                evidencias: '',
                dt_prevista_conclusao: null,
                dt_conclusao: null,
                custo: null,
                sem_custo: false,
                status: 'pendente',
                __dragKey: this.novaChaveDragResultado(),
            })
        },
        handleAdicionarResultado() {
            if (!this.podeEditar) return
            if (this.bloquearEdicaoResultados) {
                if (this.podeSolicitarPedidoEdicaoResultados) {
                    this.abrirPedidoNovoResultado()
                }
                return
            }
            this.adicionarResultado()
        },
        async removerResultado(index) {
            const row = this.PCM.resultados[index]
            const excluir = row?.id ? [row.id] : []
            this.PCM.resultados.splice(index, 1)
            if (this.PCM.resultados.length === 0) {
                this.PCM.resultados.push({
                    nome: '',
                    problema: '',
                    descricao: '',
                    evidencias: '',
                    dt_prevista_conclusao: null,
                    dt_conclusao: null,
                    custo: null,
                    sem_custo: false,
                    status: 'pendente',
                    __dragKey: this.novaChaveDragResultado(),
                })
            }
            await this.salvarResultados(excluir)
        },
        handleRemoverResultado(index) {
            if (!this.podeEditar || !this.podeAlterarStatusResultados) return
            this.removerResultado(index)
        },
        valorAtualAtributoResultado(resultado, atributo) {
            if (atributo === 'sem_custo') {
                return resultado?.sem_custo ? '1' : '0'
            }
            if (atributo === 'custo') {
                if (resultado?.sem_custo || resultado?.custo === '' || resultado?.custo == null) return ''
                return String(this.converterCustoParaNumero(resultado.custo))
            }
            if (atributo === 'dt_prevista_conclusao' || atributo === 'dt_conclusao') {
                if (!resultado?.[atributo]) return ''
                return String(resultado[atributo]).slice(0, 10)
            }
            return resultado?.[atributo] ?? ''
        },
        podeSolicitarPedidoCampoResultado(res) {
            return this.podeSolicitarPedidoEdicaoResultados && res?.id != null
        },
        podeSolicitarExclusaoResultado(res) {
            if (!this.podeSolicitarPedidoCampoResultado(res)) return false
            // Auditor já tem Excluir direto em resultados pendentes
            if (this.isAuditor116 && this.statusNormalizado(res) === 'pendente') return false
            return true
        },
        opcoesAtributoPedidoResultado() {
            const opcoes = [
                { valor: 'nome', label: 'Nome' },
                { valor: 'descricao', label: 'Especificação da entrega' },
                { valor: 'evidencias', label: 'Evidências' },
                { valor: 'dt_prevista_conclusao', label: 'Data prevista de conclusão' },
            ]
            if (this.isAuditor116) {
                opcoes.push({ valor: 'dt_conclusao', label: 'Data de conclusão' })
            }
            if (this.isGerenteOuAssessor || this.parteDoComite) {
                opcoes.push({ valor: 'custo', label: 'Custo previsto' })
            }
            return opcoes
        },
        abrirPedidoEdicaoResultado(res, idx) {
            if (!this.podeSolicitarPedidoCampoResultado(res)) return
            this.pedidoEdicao = {
                pcm_id: this.PCM.id,
                campo: null,
                valor_atual: '',
                valor_atual_sem_custo: res.sem_custo ? '1' : '0',
                novo_valor: null,
                justificativa: '',
                obs: '',
                _selecionarAtributo: true,
                _resultadoId: res.id,
                _resultadoIndice: idx + 1,
                _resultadoSnapshot: this.normalizarResultadoParaPayload(res),
                _atributosOpcoes: this.opcoesAtributoPedidoResultado(),
                _label: `Entrega ${idx + 1}`,
            }
        },
        abrirPedidoCampoResultado(res, idx, atributo) {
            if (!this.podeSolicitarPedidoCampoResultado(res)) return
            const meta = service.atributosResultado[atributo]
            this.pedidoEdicao = {
                pcm_id: this.PCM.id,
                campo: service.montarCampoPedidoResultado(res.id, atributo),
                valor_atual: this.valorAtualAtributoResultado(res, atributo),
                valor_atual_sem_custo: res.sem_custo ? '1' : '0',
                novo_valor: atributo === 'sem_custo' ? '1' : null,
                _label: service.labelCampoPedido(
                    service.montarCampoPedidoResultado(res.id, atributo),
                    { indice: idx + 1 },
                ),
                _tipo: meta?.tipo,
            }
        },
        abrirPedidoNovoResultado() {
            if (!this.podeSolicitarPedidoEdicaoResultados) return
            this.pedidoEdicao = {
                pcm_id: this.PCM.id,
                campo: service.montarCampoPedidoNovoResultado(),
                valor_atual: '',
                novo_valor: null,
                _label: 'Nova entrega',
            }
        },
        abrirPedidoExcluirResultado(res, idx) {
            if (!this.podeSolicitarPedidoCampoResultado(res)) return
            this.pedidoEdicao = {
                pcm_id: this.PCM.id,
                campo: service.montarCampoPedidoExcluirResultado(res.id),
                valor_atual: JSON.stringify(this.normalizarResultadoParaPayload(res)),
                novo_valor: '(exclusão)',
                _label: service.labelCampoPedido(
                    service.montarCampoPedidoExcluirResultado(res.id),
                    { indice: idx + 1 },
                ),
            }
        },
        normalizarResultadoParaPayload(resultado) {
            return {
                id: resultado?.id ?? null,
                nome: resultado?.nome ?? '',
                problema: resultado?.problema ?? '',
                descricao: resultado?.descricao ?? '',
                evidencias: resultado?.evidencias ?? '',
                dt_prevista_conclusao: resultado?.dt_prevista_conclusao === '' || resultado?.dt_prevista_conclusao == null
                    ? null
                    : String(resultado.dt_prevista_conclusao).slice(0, 10),
                dt_conclusao: resultado?.dt_conclusao === '' || resultado?.dt_conclusao == null
                    ? null
                    : String(resultado.dt_conclusao).slice(0, 10),
                sem_custo: !!resultado?.sem_custo,
                custo: resultado?.sem_custo || resultado?.custo === '' || resultado?.custo == null
                    ? null
                    : this.converterCustoParaNumero(resultado.custo),
                status: this.statusNormalizado(resultado),
            }
        },
        converterCustoParaNumero(valor) {
            if (valor === '' || valor == null) return 0
            if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0

            const bruto = String(valor).replace(/[^\d,.-]/g, '')
            if (!bruto) return 0

            const temVirgula = bruto.includes(',')
            const temPonto = bruto.includes('.')
            let normalizado = bruto

            if (temVirgula && temPonto) {
                // Ex: 1.234,56 -> remove milhar e usa vírgula como decimal
                normalizado = bruto.replace(/\./g, '').replace(',', '.')
            } else if (temVirgula) {
                // Ex: 123,45
                normalizado = bruto.replace(',', '.')
            } else {
                // Ex: 123.45 (já decimal) ou 12345 (inteiro)
                normalizado = bruto
            }

            const numero = Number(normalizado)
            return Number.isFinite(numero) ? numero : 0
        },
        async criarPedidoEdicao(pedido) {
            if (!this.podeEditar) return
            const dados = pedido || this.pedidoEdicao
            if (dados?.campo === 'estimativa_custo') return
            this.mensagemEdicao = await service.criarPedidoEdicao(dados);
            this.$emit('getProjeto')
            this.getPedidosEdicao();
        },
        abrirModal(campo) {
            if (!this.podeEditar || campo === 'estimativa_custo') return
            this.pedidoEdicao = {
                pcm_id: this.PCM.id,
                campo: campo,
            }
        },
        removerMembro(id) {
            if (!this.podeEditar) return
            this.PCM.comite_aprovacao = this.PCM.comite_aprovacao.filter(u => u.id !== id)
            var payload = this.PCM.comite_aprovacao.map(i => i.id);
            this.atualizarPCM('comite_aprovacao', payload)
        },
        adicionarMembro(user) {
            if (!this.podeEditar) return
            this.PCM.comite_aprovacao.push({ id: user.id, name: user.nomeCompleto ?? user.name })
            this.atualizarPCM('comite_aprovacao', this.PCM.comite_aprovacao.map(i => i.id))
        },
        dataParaInput(valor) {
            return formatarDataParaInput(valor);
        },
        labelCampoPedido(pedido) {
            const parsed = service.parseCampoPedidoResultado(pedido?.campo)
            let indice = null
            if (parsed?.resultadoId != null) {
                indice = service.indiceResultadoPorId(this.PCM.resultados, parsed.resultadoId)
            }
            return service.labelCampoPedido(pedido?.campo, { indice })
                || this.campos[pedido?.campo]?.label
                || pedido?.campo
        },
        metaCampoPedido(pedido) {
            return service.metaCampoPedido(pedido?.campo) || this.campos[pedido?.campo] || null
        },
        usaTextareaPedido(pedido) {
            const parsed = service.parseCampoPedidoResultado(pedido?.campo)
            if (!parsed) return false
            if (parsed.tipo === 'lista' || parsed.tipo === 'novo' || parsed.tipo === 'excluir') return true
            if (parsed.tipo === 'campo'
                && ['problema', 'descricao', 'evidencias'].includes(parsed.atributo)) {
                return true
            }
            return false
        },
        formatarValorPedidoExibicao(pedido, qual) {
            const parsed = service.parseCampoPedidoResultado(pedido?.campo)
            if (parsed?.tipo === 'lista') {
                return qual === 'atual'
                    ? this.resumoPedidoResultados(pedido).valorAntigo
                    : this.resumoPedidoResultados(pedido).novoValor
            }
            return service.formatarValorPedidoResultado(pedido, qual)
        },
        parseResultadosPedido(valor) {
            if (!valor) return []
            try {
                const parsed = JSON.parse(valor)
                return Array.isArray(parsed) ? parsed : []
            } catch (_) {
                return []
            }
        },
        normalizarTexto(valor) {
            return (valor ?? '').toString().trim()
        },
        normalizarCusto(valor) {
            if (valor === '' || valor == null) return null
            const n = this.converterCustoParaNumero(valor)
            return Number.isFinite(n) ? n : null
        },
        textoParaResumo(valor) {
            const t = (valor ?? '').toString()
            return t.trim() === '' ? '(vazio)' : t
        },
        custoParaResumo(valor) {
            const n = this.normalizarCusto(valor)
            if (n == null) return '(vazio)'
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)
        },
        resumoItemCompleto(item, rotulo) {
            return service.resumoItemResultadoCompleto(item, rotulo)
        },
        resumoPedidoResultados(pedido) {
            const anterior = this.parseResultadosPedido(pedido?.valor_atual)
            const proposto = this.parseResultadosPedido(pedido?.novo_valor)

            const porIdAnterior = new Map(
                anterior
                    .filter(i => i && i.id != null)
                    .map(i => [String(i.id), i])
            )
            const porIdProposto = new Map(
                proposto
                    .filter(i => i && i.id != null)
                    .map(i => [String(i.id), i])
            )

            const blocosAntigo = []
            const blocosNovo = []

            blocosAntigo.push(`Total de itens antes: ${anterior.length}`)
            blocosNovo.push(`Total de itens na proposta: ${proposto.length}`)

            proposto.forEach((itemNovo, idx) => {
                const indice = idx + 1
                if (itemNovo?.id == null) {
                    blocosAntigo.push(`—\nItem ${indice} (novo): não existia na lista anterior.`)
                    blocosNovo.push(`—\n${this.resumoItemCompleto(itemNovo, `Item ${indice} (novo)`)}`)
                    return
                }

                const itemAntigo = porIdAnterior.get(String(itemNovo.id))
                if (!itemAntigo) {
                    blocosAntigo.push(`—\nItem ${indice}: não existia na lista anterior (id ${itemNovo.id}).`)
                    blocosNovo.push(`—\n${this.resumoItemCompleto(itemNovo, `Item ${indice}`)}`)
                    return
                }

                const partesAntigo = []
                const partesNovo = []
                let houveAlteracao = false

                if (this.normalizarTexto(itemAntigo.descricao) !== this.normalizarTexto(itemNovo.descricao)) {
                    houveAlteracao = true
                    partesAntigo.push(`Descrição (antes):\n${this.textoParaResumo(itemAntigo.descricao)}`)
                    partesNovo.push(`Descrição (depois):\n${this.textoParaResumo(itemNovo.descricao)}`)
                }
                if (this.normalizarTexto(itemAntigo.evidencias) !== this.normalizarTexto(itemNovo.evidencias)) {
                    houveAlteracao = true
                    partesAntigo.push(`Evidências (antes):\n${this.textoParaResumo(itemAntigo.evidencias)}`)
                    partesNovo.push(`Evidências (depois):\n${this.textoParaResumo(itemNovo.evidencias)}`)
                }
                if (!!itemAntigo.sem_custo !== !!itemNovo.sem_custo
                    || this.normalizarCusto(itemAntigo.custo) !== this.normalizarCusto(itemNovo.custo)) {
                    houveAlteracao = true
                    partesAntigo.push(itemAntigo.sem_custo
                        ? 'Custo (antes): esta entrega não terá custo'
                        : `Custo (antes): ${this.custoParaResumo(itemAntigo.custo)}`)
                    partesNovo.push(itemNovo.sem_custo
                        ? 'Custo (depois): esta entrega não terá custo'
                        : `Custo (depois): ${this.custoParaResumo(itemNovo.custo)}`)
                }
                const prevAnt = itemAntigo.dt_prevista_conclusao ? String(itemAntigo.dt_prevista_conclusao).slice(0, 10) : ''
                const prevNovo = itemNovo.dt_prevista_conclusao ? String(itemNovo.dt_prevista_conclusao).slice(0, 10) : ''
                if (prevAnt !== prevNovo) {
                    houveAlteracao = true
                    partesAntigo.push(`Data prevista (antes): ${prevAnt || '(vazio)'}`)
                    partesNovo.push(`Data prevista (depois): ${prevNovo || '(vazio)'}`)
                }
                const concAnt = itemAntigo.dt_conclusao ? String(itemAntigo.dt_conclusao).slice(0, 10) : ''
                const concNovo = itemNovo.dt_conclusao ? String(itemNovo.dt_conclusao).slice(0, 10) : ''
                if (concAnt !== concNovo) {
                    houveAlteracao = true
                    partesAntigo.push(`Data de conclusão (antes): ${concAnt || '(vazio)'}`)
                    partesNovo.push(`Data de conclusão (depois): ${concNovo || '(vazio)'}`)
                }

                if (houveAlteracao) {
                    blocosAntigo.push(`—\nItem ${indice}:\n${partesAntigo.join('\n\n')}`)
                    blocosNovo.push(`—\nItem ${indice}:\n${partesNovo.join('\n\n')}`)
                }
            })

            anterior.forEach((itemAntigo, idx) => {
                if (itemAntigo?.id == null) return
                if (porIdProposto.has(String(itemAntigo.id))) return
                const indice = idx + 1
                blocosAntigo.push(`—\n${this.resumoItemCompleto(itemAntigo, `Item ${indice} (será removido)`)}`)
                blocosNovo.push(`—\nItem ${indice}: removido na proposta.`)
            })

            const valorAntigoResumo = blocosAntigo.join('\n')
            const novoValorResumo = blocosNovo.join('\n')

            return {
                valorAntigo: valorAntigoResumo || 'Sem alterações detectadas',
                novoValor: novoValorResumo || 'Sem alterações detectadas',
            }
        },
        async aprovarPedidoEdicao(id, status) {
            if (!this.podeEditar) return
            const obs = this.obsAprovacaoPorPedido[id] ?? null;
            await service.aprovarPedidoEdicao(id, status, obs);
            delete this.obsAprovacaoPorPedido[id];
            this.$emit('getProjeto')
            this.getPedidosEdicao()
        },
        async getPedidosEdicao() {
            var response = await service.getPedidosEdicao(this.PCM.id);
            response.forEach(item => {
                if (item.campo === 'estimativa_custo') {
                    item.valor_atual = parseFloat(item.valor_atual).toFixed(2);
                }
            });

            this.pedidos_edicao = response
        },
        async atualizarPCM(itemEditado, valor) {
            if (!this.podeEditar) return
            if (itemEditado === 'status') {
                var hoje = formatarDataParaInput(new Date().toISOString())
                // salva quem foi a pessoal que apertou o botao e a data
                this.PCM.responsavel_id === null ? this.PCM.responsavel_id = this.idUsuario : null;
                await this.atualizarPCM('responsavel_id', this.idUsuario);
                this.PCM.responsavel_id = this.idUsuario
                await this.atualizarPCM('dtAprovacao', hoje);
                this.PCM.dtAprovacao = hoje;
                if (valor === 'Aprovado') {
                    await this.atualizarProjeto('status', 'Em andamento');
                }
                else if (valor === 'Reprovado') {
                    await this.atualizarProjeto('status', 'Reprovado');
                }
            }
            await service.atualizarPCM(itemEditado, valor, this.PCM.id)
            if (itemEditado === 'gerentePCM_id' && this.PCM.id_associacao) {
                this.$emit('getProjeto')
            }
            // comite_aprovacao envia só os IDs na API; manter os objetos { id, name } já atualizados na tela
            if (itemEditado !== 'comite_aprovacao') {
                this.PCM[itemEditado] = valor
            }
        },
        async atualizarProjeto(itemEditado, valor) {
            if (!this.PCM.id_associacao) return
            var payload = {
                [itemEditado]: valor,
            }
            await serviceProjetos.atualizarProjeto(this.PCM.id_associacao, payload)
        },
    },
}
</script>
<style scoped>
.pedido-mudanca-status {
    align-self: end;
}

@media screen and (min-width: 971px) {
    .pedido-mudanca-status {
        grid-column: 4;
    }
}

.chip {
    font-size: 16px;
    cursor: pointer;
}

.lista-anexos {
    list-style: none;
    padding-left: 0;
    margin-top: 10px;
}

.lista-anexos li {
    display: flex;
    align-items: center;
    gap: .5rem;
    padding: 6px 0;
    border-bottom: 1px dashed var(--cor-separador, #eee);
}

.lista-anexos .nome {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

:disabled,
input:read-only,
textarea:read-only {
    border: 1px solid var(--cor-separador) !important;
}

.inputValor {
    border: 1px solid var(--cor-separador);
    font-size: 16px;
    border-radius: 6px;
    height: 48px;
    padding: 12px 16px;
    width: 100%;
}

.membroComite {
    i {
        display: none;
    }
}

.membroComite:hover {
    i {
        display: inline;
    }
}

td {
    textarea {
        margin: .5rem 0;
    }
}

.reprovar {
    background-color: var(--cor-erro);
    color: var(--cor-bg);
}

.aprovar {
    background-color: var(--cor-sucesso);
    color: var(--cor-bg);
}

:disabled {
    cursor: not-allowed;
}

.pcm-money.inputValor {
    width: 100%;
    height: 48px;
    box-sizing: border-box;
    border: 1px solid var(--cor-separador);
    border-radius: 6px;
    padding: 12px 16px;
    background: var(--cor-bg);
    color: var(--cor-fonte);
    font: inherit;
}

.pcm-resultados-lista {
    display: grid;
    gap: 1rem;
    margin-top: 0.5rem;
}

.pcm-resultado-card {
    padding: 1rem;
    border: 1px solid var(--cor-separador);
    border-radius: 8px;
    background: var(--cor-bg);
}

.pcm-resultado-card__cabecalho {
    display: grid;
    grid-template-columns: auto auto minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 0.65rem;
}

/* O rótulo ocupa a linha de cima da coluna do campo; os demais itens ficam na linha do input. */
.pcm-resultado-card__cabecalho-rotulo {
    grid-column: 3;
    grid-row: 1;
}

.pcm-resultado-card__cabecalho>.pcm-resultado-drag-handle,
.pcm-resultado-card__cabecalho>.pcm-resultado-card__indice,
.pcm-resultado-card__cabecalho>.pcm-status-chip {
    grid-row: 2;
}

.pcm-resultado-card__cabecalho>.pcm-resultado-card__nome {
    grid-column: 3;
    grid-row: 2;
}

.pcm-resultado-drag-handle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 1.75rem;
    cursor: grab;
    color: var(--cor-texto-secundario, #666);
}

.pcm-resultado-drag-handle:active {
    cursor: grabbing;
}

.pcm-resultado-drag-handle--oculto {
    visibility: hidden;
    cursor: default;
}

.pcm-resultado-card__indice {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    background: var(--cor-primaria-fraca);
    color: var(--cor-primaria-forte);
    font-weight: 700;
}

.pcm-resultado-card label {
    display: block;
    margin-bottom: 0.3rem;
    color: var(--cor-fonte-fraca);
    font-size: 0.8rem;
    font-weight: 600;
}

.pcm-resultado-card input:not([type="checkbox"]),
.pcm-resultado-card textarea {
    width: 100%;
    box-sizing: border-box;
}

.pcm-resultado-card textarea {
    resize: vertical;
}

.pcm-resultado-card__problema {
    margin-top: 0.85rem;
}

.pcm-resultado-card__conteudo {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
    margin-top: 0.85rem;
}

.pcm-resultado-card__rodape {
    display: grid;
    grid-template-columns: minmax(10rem, 0.8fr) minmax(10rem, 0.8fr) minmax(13rem, 1.4fr);
    gap: 1rem;
    align-items: start;
    margin-top: 0.85rem;
    padding-top: 0.85rem;
    border-top: 1px solid var(--cor-separador);
}

.pcm-celula-campo--custo {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.pcm-resultado-card label.pcm-check-sem-custo {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    width: fit-content;
    margin: 0;
    font-weight: normal;
    color: var(--cor-texto-secundario, #555);
    cursor: pointer;
}

.pcm-check-sem-custo input[type="checkbox"] {
    flex-shrink: 0;
    margin: 0;
}

.pcm-aviso-sem-custo {
    margin: 0;
    padding: 0.75rem;
    border-radius: 6px;
    background: color-mix(in srgb, var(--cor-separador, #eee) 70%, transparent);
    color: var(--cor-texto-secundario, #555);
    font-size: 0.88rem;
}

.pcm-resultado-card__acoes {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 0.85rem;
    padding-top: 0.85rem;
    border-top: 1px solid var(--cor-separador);
}

.pcm-btn-pedir-edicao {
    width: auto;
    padding: 0.5rem 0.85rem;
    white-space: nowrap;
}

.pcm-acao-resultado {
    width: auto;
    padding: 0.5rem 0.85rem;
    border: 0;
}

.pcm-acao-resultado--sucesso {
    background: var(--cor-sucesso);
    color: var(--cor-bg);
}

.pcm-acao-resultado--erro {
    background: var(--cor-erro);
    color: var(--cor-bg);
}

.pcm-resultados-acoes {
    display: flex;
    justify-content: center;
    margin-top: 0.85rem;
}

.pcm-status-chip {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.85rem;
    background: var(--cor-separador, #eee);
}

.pcm-status-chip--validado,
.pcm-status-chip--concluido {
    background: color-mix(in srgb, var(--cor-sucesso, #2e7d32) 18%, transparent);
}

@media (max-width: 900px) {

    .pcm-resultado-card__conteudo,
    .pcm-resultado-card__rodape {
        grid-template-columns: 1fr;
    }

    .pcm-resultado-card__cabecalho {
        grid-template-columns: auto auto minmax(0, 1fr);
    }

    .pcm-resultado-card__cabecalho>.pcm-status-chip {
        grid-column: 3;
        grid-row: 3;
        justify-self: start;
        margin-top: 0.5rem;
    }
}

@media (max-width: 560px) {
    .pcm-resultado-card__acoes {
        justify-content: stretch;
    }

    .pcm-resultado-card__acoes button {
        width: 100%;
    }
}
</style>